// @constants
const errorActions = require('actions/brokerError');

const show = (error, history) => dispatch => {
    const errorKey = error ? error.errorKey : false;

    if (errorKey) {
        dispatch(
            errorActions.show('brokerRAAPIErrors-' + errorKey, true, history),
        );
    } else {
        dispatch(errorActions.show('', true, history));
    }
};

module.exports = {
    show,
};
